//implementacion de ngxdatatable
//https://stackoverflow.com/questions/51303630/how-to-use-edit-and-delete-options-in-angular-ngx-datatables

//solucion para usar metodos de angular en html
//https://stackblitz.com/edit/angular-c6vfcq?file=src%2Fapp%2Fapp.component.html

//solución al asignar el input date 
//https://stackblitz.com/edit/angular-xuvrtq?file=src%2Fapp%2Fapp.component.ts

import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { DatatableComponent } from '@swimlane/ngx-datatable';
import { EmptyError } from 'rxjs';
import { UsuarioService } from '../../services/usuario.service';
import { Pregunta } from '../../models/pregunta';
import { PreguntaService } from '../../services/pregunta.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $:any;

@Component({
    selector:'admin-pregunta',
    templateUrl:'./admin-pregunta.component.html',
    providers:[UsuarioService,PreguntaService],
    //styleUrls:['../']
})

export class AdminPreguntaComponent implements OnInit{
    @ViewChild('addForm') formValues:NgForm; //added this
    public title:string;
    public pregunta:Pregunta;
    public status:string;
    public errorTexto:string;
    fromDate;

    public token;

    editing = {};
    rows = [];
    columns = [];
    selected=[];
    temp = [];

    loadingIndicator:boolean = true;
    reaorderable: boolean = true;

    @ViewChild(DatatableComponent) table: DatatableComponent;

    constructor(
        private _usuarioService: UsuarioService,
        private _preguntaService: PreguntaService
    ){
        this.title = 'Catálogo de preguntas';
        this.token = this._usuarioService.getToken();
        this.inicializarClase();
        this.GRIDlistar();
}

/**
 * Métodos
 */

 inicializarClase(){
    this.pregunta = new Pregunta(0,"",new Date(),true,new Date(),new Date(),"");
    return this.pregunta;
 }

ngOnInit(){
    console.log('Componente admin pregunta cargado');
    this.token = this._usuarioService.getToken();

    this.columns = [
        { Name:'ID',prop: 'ID'},
        { name:'DESCRIPCIÓN', prop: 'DESCRIPCION'},
        { name:'ESTATUS', prop:'estatus_texto'}
    ]
}

btn_nuevo(){
    this.inicializarClase();
    $('#exampleModal').modal('show');
}

GRIDlistar(){
    this._preguntaService.GRIDlistar(this.token).subscribe(
        response =>{
            this.rows = response.items;
            this.temp = response.items;
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

    /*onSelect({ selected }) {
        console.log('Select Event', selected, this.selected);
      }*/
    
    onActivate(event) {
    if(event.type == 'click') {
        this.status = "";
        this.pregunta = event.row;
        $('#exampleModal').modal('show');
    }
}

onSubmit(){
    this._preguntaService.gestion(this.pregunta,this.token).subscribe(
        response =>{
            $('#txtBuscar').val('');
            this.GRIDlistar();
            this.formValues.resetForm(); // Added this
            this.status = "";
            $('#exampleModal').modal('hide');
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

updateFilter(event) {
    const val = event.target.value.toLowerCase();   
    // filter our data
    const temp = this.temp.filter(function(d) {
        return d.DESCRIPCION.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
}
}